// extracted by mini-css-extract-plugin
module.exports = {"paymentErrorWrapper":"PaymentError_paymentErrorWrapper__BmUIo","introText":"PaymentError_introText__yvmNm"};